module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/create-subscription/create-subscription.component.css
// module id = ./src/app/create-subscription/create-subscription.component.css
// module chunks = main